import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'
import Field from '@groovehq/internal-design-system/lib/components/Field/Field'
import TagDropdown from 'subapps/settings/components/TagDropdown'
import DropdownMenu from '../DropdownMenu'
import { styles } from './styles'

export default function RuleValue({
  value,
  onDropdownSelect,
  selectedValue,
  conditionOrAction,
  onInputBlur,
  onInputChange,
  errorMessage,
  valueKey,
  dataType = 'AUTO',
}) {
  if (dataType === 'TAGS') {
    return (
      <TagDropdown
        tagId={valueKey}
        onTagSelect={onDropdownSelect}
        size="small"
      />
    )
  }

  if (['AUTO', 'LIST'].includes(dataType) && Array.isArray(value)) {
    return (
      <div css={styles.dropdownContainer}>
        <Dropdown
          overlay={<DropdownMenu data={value} />}
          onSelect={onDropdownSelect}
        >
          <Dropdown.Button size="small" css={styles.dropdownBtn}>
            {selectedValue || <>&nbsp;</>}
          </Dropdown.Button>
        </Dropdown>
      </div>
    )
  }
  if (['AUTO', 'TEXT'].includes(dataType)) {
    return (
      <Field
        name={conditionOrAction.id || conditionOrAction.uuid}
        {...conditionOrAction}
        value={valueKey || ''}
        onChange={onInputChange}
        onBlur={onInputBlur}
        css={styles.field}
        validateStatus={errorMessage ? 'error' : undefined}
        help={errorMessage}
      />
    )
  }

  return null
}
